module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "aeris-notifier-host"
  }, [_c('div', {
    staticClass: "aeris-notifier-container"
  }, [_c('ul', _vm._l((_vm.notifications), function(notification) {
    return _c('li', {
      key: notification.uuid,
      staticClass: "notification"
    }, [_c('aeris-notification', {
      attrs: {
        "type": notification.type,
        "message": notification.message,
        "spinner": notification.spinner,
        "closable": notification.closable,
        "uuide": notification.uuid
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7701cd00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aeris-notification/aeris-notifier.vue
// module id = 176
// module chunks = 0